import Avatarmage from "../../../assets/images/svg/user.svg";

const CourseTrainerSection = ({ selectedCourseData }) => {
  const coaches = selectedCourseData?.courseCoaches || [];
  const [lead] = coaches;

  if (!lead) return null;

  return (
    <section id="instructor" className="bg-white">
      <div className="max-w-[1260px] mx-auto px-4">
        <div className="border border-[#DFE6F7] rounded-[26px] bg-white shadow-course-card mb-8 p-6 md:p-9">
          <p className="text-primary tracking-[0.19em] uppercase text-[14px] font-extrabold font-poppins flex items-center gap-2 mb-6">
            <span className="inline-block w-6 h-[3px] bg-secondary rounded-full" />
            Learn From The Field
          </p>
          <h2 className="text-primary font-poppins font-bold text-3xl md:text-5xl mb-3 tracking-tight">
            Meet Your Instructor
          </h2>
          <div className="flex flex-col md:flex-row gap-8 md:gap-10 items-center bg-[#FFFBF2] rounded-2xl p-5 md:p-7">
            <img
              src={lead.coachImage || Avatarmage}
              alt={lead.coachName}
              className="w-full md:w-course-avatar md:flex-none h-72 md:h-96 object-cover object-top rounded-2xl"
            />

            <div className="md:flex-1 min-w-0">
              <h3 className="text-[#1E2027] font-poppins text-2xl md:text-4xl mb-1">
                {lead.coachName}
              </h3>
              <p className="text-primary font-poppins uppercase tracking-wider text-lg font-extrabold">
                {lead.coachRole}
              </p>

              {lead.coachQuote && (
                <blockquote className="border-l-4 font-poppins border-secondary text-[#1E2027] pl-5 my-6 text-base md:text-lg leading-relaxed">
                  {lead.coachQuote}
                </blockquote>
              )}

              <p className="text-[#565656] font-poppins text-sm md:text-lg leading-relaxed mt-5">
                {lead.coachDesc ||
                  "Utiva instructors are experienced practitioners from innovative companies, bringing current tools, decisions, and hard-won lessons into every class."}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CourseTrainerSection;
